import React, {useState} from "react";
import {Tabs} from "antd";
import {CourierAdjustmentsTab} from "./CourierAdjustmentsTab";

const {TabPane} = Tabs;

export const CourierAdjustmentsPage = () => {
    const [activeTab, setActiveTab] = useState("details");

    return (
        <div style={{padding: "24px"}}>
            <h2>Eklentiler & Kesintiler</h2>
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
                <TabPane tab="Kurye Eklentiler & Kesintiler" key="details">
                    <CourierAdjustmentsTab isTabActive={activeTab === "details"} />
                </TabPane>
            </Tabs>
        </div>
    );
};
